/* eslint-disable quotes */

const suggestedLanguages = [
  { code: 'en', label: 'English', flagCode: 'us', tooltip: 'United States US' },
  {
    code: 'ar',
    label: 'عربي',
    flagCode: 'ae',
    tooltip: 'United Arab Emirates AE',
  },
  { code: 'es', label: 'Española', flagCode: 'es', tooltip: 'Spain ES' },
  { code: 'de', label: 'Deutschland', flagCode: 'de', tooltip: 'Germany DE' },
  {
    code: 'zh-CN',
    label: '中文',
    flagCode: 'cn',
    tooltip: 'Mainland China CN',
  },
  {
    code: 'fr',
    label: 'Français',
    flagCode: 'fr',
    tooltip: 'France FR',
    isSpecialLang: true,
  },
  {
    code: 'ru',
    label: 'русский',
    flagCode: 'ru',
    tooltip: 'Russian Federation RU',
    isSpecialLang: true,
  },
];
const otherLanguages = [
  { code: 'id', label: 'Acèh', flagCode: 'id', tooltip: 'Indonesia ID' },

  { code: 'is', label: 'Íslenska', flagCode: 'is', tooltip: 'Iceland IS' },

  {
    code: 'ab',
    label: 'Аҧсуа',
    flagCode: 'ab',
    // flagCode_local: afkhazianFlag,
    tooltip: 'Abkhazia AB',
    isSpecialLang: true,
  },

  {
    code: 'udm',
    label: 'Удмурт кыл',
    flagCode: 'ru',
    tooltip: 'Russian Federation RU',
  },

  {
    code: 'az',
    label: 'Azərbaycan dili',
    flagCode: 'az',
    tooltip: 'Azerbaijan AZ',
  },

  { code: 'ur', label: 'اردو', flagCode: 'pk', tooltip: 'Pakistan PK' },

  {
    code: 'hy',
    label: 'Հայերեն',
    flagCode: 'am',
    tooltip: 'Armenia AM',
  },

  {
    code: 'as',
    label: 'অসমীয়া',
    flagCode: 'in',
    tooltip: 'India IN',
  },

  { code: 'eo', label: 'Esperanto', flagCode: 'pl', tooltip: 'Poland PL' },

  { code: 'et', label: 'Eesti', flagCode: 'ee', tooltip: 'Estonia EE' },

  { code: 'ach', label: 'Acoliland', flagCode: 'ug', tooltip: 'Uganda UG' },

  {
    code: 'aa',
    label: 'Afár',
    flagCode: 'et',
    tooltip: 'Ethiopia ET',
  },

  // { code: 'aa', label: 'بعيد', flagCode: 'dj' },
  {
    code: 'af',
    label: 'Afrikaans',
    flagCode: 'za',
    tooltip: 'South Africa ZA',
  },

  { code: 'sq', label: 'Shqip', flagCode: 'al', tooltip: 'Albania AL' },

  {
    code: 'ber-Latn',
    label: 'Tamazight',
    flagCode: 'ma',
    tooltip: 'Morocco MA',
  },

  {
    code: 'am',
    label: 'አማርኛ',
    flagCode: 'et',
    tooltip: 'Ethiopia ET',
  },

  {
    code: 'awa',
    label: 'Bahasa Indonesia',
    flagCode: 'id',
    tooltip: 'Indonesia ID',
  },

  // { code: 'av', label: 'عوضي', flagCode: 'ru' },

  { code: 'or', label: 'ଓଡ଼ିଆ', flagCode: 'in', tooltip: 'India IN' },

  { code: 'om', label: 'Afaan Oromoo', flagCode: 'et', tooltip: 'Ethiopia ET' },
  { code: 'uz', label: 'Ўзбек тили', flagCode: 'uz', tooltip: 'Uzbekistan UZ' },

  // { code: 'or', label: 'Odia (Oriya)', flagCode: 'in' },
  // { code: 'om', label: 'Oromo', flagCode: 'et' },

  // { code: 'uz', label: 'Ўзбек тили', flagCode: 'uz' },
  { code: 'os', label: 'Дигорон', flagCode: 'ir', tooltip: 'Iran IR' },

  { code: 'uk', label: 'Ukrainian', flagCode: 'ua', tooltip: 'Ukraine UA' },

  {
    code: 'oc',
    label: 'Lenga d\'Òc',
    flagCode: 'fr',
    tooltip: 'France FR',
    isSpecialLang: true,
  },

  {
    code: 'ug',
    label: 'ئۇيغۇر تىلى',
    flagCode: 'tc',
    tooltip: 'Turks and Caicos Islands TC',
  },

  { code: 'iba', label: 'Bahasa Iban', flagCode: 'my', tooltip: 'Malaysia MY' },

  {
    code: 'ga',
    label: 'Gaeilge',
    flagCode: 'ie',
    tooltip: 'Ireland IE',
    isSpecialLang: true,
  },

  {
    code: 'it',
    label: 'Italiano',
    flagCode: 'it',
    tooltip: 'Italy IT',
    isSpecialLang: true,
  },

  {
    code: 'ig',
    label: 'Asụsụ Igbo',
    flagCode: 'ng',
    tooltip: 'Nigeria NG',
    isSpecialLang: true,
  },

  { code: 'ilo', label: 'Ilokano', flagCode: 'ph', tooltip: 'Phillipeans PH' },

  {
    code: 'ay',
    label: 'Aymar aru',
    flagCode: 'as',
    tooltip: 'American Samoa AS',
  },

  { code: 'ee', label: 'Eʋegbe', flagCode: 'ne', tooltip: 'Niger NE' },

  // { code: 'ee', label: 'Eʋegbe', flagCode: 'gh' },

  { code: 'pap', label: 'Papiamentu', flagCode: 'aw', tooltip: 'Aruba AW' },

  {
    code: 'bts',
    label: 'Bahasa Batak Simalungun',
    flagCode: 'id',
    tooltip: 'Indonesia ID',
  },

  {
    code: 'bbc',
    label: 'Bahasa Batak Toba',
    flagCode: 'id',
    tooltip: 'Indonesia ID',
  },

  {
    code: 'btx',
    label: 'Bahasa Karo',
    flagCode: 'id',
    tooltip: 'Indonesia ID',
  },

  { code: 'jam', label: 'Patwa', flagCode: 'jm', tooltip: 'Jamaica JM' },

  { code: 'eu', label: 'Euskara', flagCode: 'es', tooltip: 'Spain ES' },

  { code: 'ps', label: 'پښتو', flagCode: 'af', tooltip: 'Afghanistan AF' },

  {
    code: 'ba',
    label: 'Башҡорт теле',
    flagCode: 'ru',
    tooltip: 'Russian Federation RU',
  },

  { code: 'ban', label: 'Basa Bali', flagCode: 'id', tooltip: 'Indonesia ID' },

  {
    code: 'bm',
    label: 'Bamanankan',
    flagCode: 'ml',
    tooltip: 'Mali ML',
    isSpecialLang: true,
  },

  {
    code: 'pag',
    label: 'Salitan Pangasinan',
    flagCode: 'ph',
    tooltip: 'Phillipeans PH',
  },

  {
    code: 'bew',
    label: 'Bahasa Betawi',
    flagCode: 'id',
    tooltip: 'Indonesia ID',
  },

  { code: 'pt-PT', label: 'Português', flagCode: 'pt', tooltip: 'Portugal PT' },

  {
    code: 'br',
    label: 'Brezhoneg',
    flagCode: 'fr',
    tooltip: 'France FR',
    isSpecialLang: true,
  },

  {
    code: 'bg',
    label: 'Български език',
    flagCode: 'bg',
    tooltip: 'Bulgaria BG',
  },

  { code: 'bal', label: 'بلوچی', flagCode: 'pk', tooltip: 'Pakistan PK' },

  { code: 'pa-Arab', label: 'ਪੰਜਾਬੀ', flagCode: 'pk', tooltip: 'Pakistan PK' },

  // { code: 'pa', label: 'Punjabi', flagCode: 'pk' },

  { code: 'bn', label: 'বাংলা', flagCode: 'bd', tooltip: 'Bangladesh BD' },

  { code: 'new', label: 'नेपली भाषा', flagCode: 'np', tooltip: 'Nepal NP' },

  { code: 'bho', label: 'भोजपुरी', flagCode: 'in', tooltip: 'Indonesia ID' },

  {
    code: 'bua',
    label: 'Буряад хэлэн',
    flagCode: 'ru',
    tooltip: 'Russian Federation RU',
  },
  {
    code: 'bs',
    label: 'Bosanski jezik',
    flagCode: 'ba',
    tooltip: 'Bosnia and Herzegovina BA',
  },
  { code: 'pl', label: 'Język polski', flagCode: 'pl', tooltip: 'Poland PL' },

  { code: 'bik', label: 'Bikol', flagCode: 'ph', tooltip: 'Phillipeans PH' },
  {
    code: 'be',
    label: 'Беларуская мова',
    flagCode: 'by',
    tooltip: 'Belarus BY',
  },

  { code: 'bem', label: 'Icibemba', flagCode: 'zm', tooltip: 'Zambia ZM' },

  { code: 'ta', label: 'தமிழ்', flagCode: 'in', tooltip: 'India IN' },
  {
    code: 'ty',
    label: 'Reo Tahiti',
    flagCode: 'pf',
    tooltip: 'French Polynesia PF',
  },
  { code: 'th', label: 'ภาษาไทย', flagCode: 'th', tooltip: 'Thailand TH' },

  {
    code: 'tt',
    label: 'Татар теле',
    flagCode: 'ru',
    tooltip: 'Russian Federation RU',
  },
  {
    code: 'tk',
    label: 'Türkmen dili',
    flagCode: 'tm',
    tooltip: 'Turkmenistan TM',
  },
  { code: 'tr', label: 'Türkçe', flagCode: 'tr', tooltip: 'Turkey TR' },

  { code: 'tn', label: 'Setswana', flagCode: 'za', tooltip: 'South Africa ZA' },
  { code: 'ts', label: 'Xitsonga', flagCode: 'za', tooltip: 'South Africa ZA' },

  {
    code: 'ch',
    label: 'Chamoru',
    flagCode: 'mp',
    tooltip: 'Northern Mariana Islands MP',
  },

  {
    code: 'cv',
    label: 'Чӑваш чӗлхи',
    flagCode: 'ru',
    tooltip: 'Russian Federation RU',
  },
  {
    code: 'chk',
    label: 'Fóósun Chuuk',
    flagCode: 'fm',
    tooltip: 'Federated States of Micronesia FM',
  },
  {
    code: 'cs',
    label: 'Čeština',
    flagCode: 'cz',
    tooltip: 'Czech Republic CZ',
  },
  { code: 'tyv', label: 'Тыва дыл', flagCode: 'tv', tooltip: 'Tuvalu TV' },
  {
    code: 'tpi',
    label: 'Tok Pisin',
    flagCode: 'gn',
    tooltip: 'Guinea GN',
    isSpecialLang: true,
  },
  { code: 'tcy', label: 'ತುಳು ಭಾಷೆ', flagCode: 'in', tooltip: 'Paraguay PY' },
  { code: 'tum', label: 'ChiTumbuka', flagCode: 'zm', tooltip: 'Zambia ZM' },
  { code: 'to', label: 'Faka-Tonga', flagCode: 'to', tooltip: 'Tonga TO' },

  {
    code: 'bo',
    label: 'བོད་སྐད',
    flagCode: 'cn',
    tooltip: 'Mainland China CN',
  },

  { code: 'te', label: 'తెలుగు', flagCode: 'in', tooltip: 'India IN' },

  { code: 'gl', label: 'Galego', flagCode: 'es', tooltip: 'Spain ES' },

  { code: 'jw', label: 'Basa Jawa', flagCode: 'id', tooltip: 'Indonesia ID' },

  { code: 'gn', label: 'Aña ñe\'ẽ', flagCode: 'py', tooltip: 'Paraguay PY' },

  { code: 'ka', label: 'ქართული ენა', flagCode: 'ge', tooltip: 'Georgia GE' },
  { code: 'ro', label: 'Limba română', flagCode: 'md', tooltip: 'Moldova MD' },

  {
    code: 'zh-CN',
    label: '中文',
    flagCode: 'cn',
    tooltip: 'Mainland China CN',
  },
  { code: 'sa', label: 'संस्कृतम्', flagCode: 'in', tooltip: 'India IN' },
  { code: 'gu', label: 'ગુજરાતી', flagCode: 'in', tooltip: 'India IN' },

  {
    code: 'rom',
    label: 'Romani',
    flagCode: 'ro',
    tooltip: 'Romania RO',
    isSpecialLang: true,
  },

  { code: 'sl', label: 'Slovenščina', flagCode: 'si', tooltip: 'Slovenia SI' },
  { code: 'sd', label: 'سنڌي', flagCode: 'pk', tooltip: 'Pakistan PK' },
  { code: 'sv', label: 'Svenska', flagCode: 'se', tooltip: 'Sweden SE' },

  { code: 'tl', label: 'Filipino', flagCode: 'ph', tooltip: 'Phillipeans PH' },

  { code: 'vi', label: 'Tiếng Việt', flagCode: 'vn', tooltip: 'Viet Nam VN' },
  { code: 'sr', label: 'Српски језик', flagCode: 'rs', tooltip: 'Serbia RS' },
  { code: 'ml', label: 'മലയാളം', flagCode: 'in', tooltip: 'India IN' },
  { code: 'kn', label: 'ಕನ್ನಡ', flagCode: 'in', tooltip: 'India IN' },

  {
    code: 'hr',
    label: 'Hrvatski jezik',
    flagCode: 'hr',
    tooltip: 'Croatia HR',
  },
  { code: 'hi', label: 'हिन्दी', flagCode: 'in', tooltip: 'India IN' },
];
export { suggestedLanguages, otherLanguages };
